document.addEventListener('DOMContentLoaded', () => {

    const targetSelector = '.ocu-cart-drawer';
    const visibleClass = 'ocu-visible';

    const targetProducts = [
        "Clay Mastery Bundle",
        "All-in-One Grooming Kit",
        "Weightless Texture Bundle",
        "Beach Styling Kit",
        "Buy 4, Get 2 Volume Cream Bundle",
        "Buy 4, Get 2 Clay Texture Powder Bundle",
        "Ultimate Texture System",
        "Best Sellers Bundle",
        "Joe's Favorites Bundle"
    ]; 

    // 👉 New Function: Updates the text in the reward bar tiers
    function updateRewardBarLabels() {
        const rewardBar = document.querySelector('.ocu-reward-bar-progress');

        if(rewardBar) {
            const labels = ['20% OFF', '25% OFF', '30% OFF + FREE SHIPPING'];            
            const rewardBarTiers = rewardBar.querySelectorAll('.ocu-reward-bar-tier');

            if(rewardBarTiers.length > 0) {
                console.log(`Found ${rewardBarTiers.length} reward bar tiers. Updating labels.`);

                rewardBarTiers.forEach((tier, index) => {
                    if (labels[index]) {
                        // Find the span element inside the current tier
                        const spanElement = tier.querySelector('.ocu-reward-bar--tier-headline span');
                        
                        if (spanElement) {
                            // Update the text content of the span
                            spanElement.textContent = labels[index];
                            console.log(`Updated tier ${index + 1} with: ${labels[index]}`);
                        }
                    }
                });

            } else {
                console.log('Reward bar tier items not found.');
            }
        } else {
            console.log('REWARD BAR NOT PRESENT');
        }
    }


    // 👉 Shared function: adds extra spans to matching products
    function enhanceCartLineItems() {
        
        // 1. Update the Reward Bar labels
        updateRewardBarLabels();

        // 2. Add/check for discount messages on products
        document
            .querySelectorAll('.ocu-cart-line-item .ocu-cart-line-item-info .ocu-cart-line-item-product-title span')
            .forEach(span => {
                const productTitle = span.textContent.trim();

                if (targetProducts.includes(productTitle)) {

                    // ✅ PREVENT DUPLICATES:
                    const parent = span.parentElement;
                    const existing = parent.querySelector('.product-discount-message');
                    const existing2 = parent.querySelector('.product-exclusive-message');
                    if (existing || existing2) return;

                    const extraSpan = document.createElement('span');
                    const extraSpan2 = document.createElement('span');

                    extraSpan.classList.add('product-discount-message');
                    extraSpan.textContent = 'Black Friday Exclusive';

                    extraSpan2.classList.add('product-exclusive-message');
                    extraSpan2.textContent = '*Already discounted. Excluded from tiered promo.';

                    // Make sure order is: original span -> extraSpan -> extraSpan2
                    span.insertAdjacentElement('afterend', extraSpan2);
                    span.insertAdjacentElement('afterend', extraSpan);

                } else {
                    // console.log('not found:', productTitle); // Commented out to reduce console noise
                }
            });
    }


    // --- Stage 2 Function: monitors the cart drawer once it's available ---
    function observeCartClass(targetNode) {
        console.log(`[Stage 2] Element found. Starting class change observer on: ${targetSelector}`);

        const config = { 
            attributes: true, 
            attributeFilter: ['class']
        };

        let itemsObserverAttached = false;
        let itemsObserver = null; // Declare the observer instance

        // 🛑 FIX: Wrapper function to disconnect/reconnect the observer
        function enhanceCartLineItemsWithObserver() {
            if (itemsObserver) {
                // 1. 🛑 Disconnect the observer *before* making DOM changes
                itemsObserver.disconnect();
                console.log('%cObserver temporarily disconnected for DOM mutation.', 'color: orange;');
            }

            // Call the original DOM-modifying function
            enhanceCartLineItems(); 

            if (itemsObserver) {
                // 2. ✅ Reconnect the observer *after* making DOM changes
                itemsObserver.observe(targetNode, {
                    childList: true,
                    subtree: true
                });
                console.log('%cObserver reconnected and watching for further changes.', 'color: green;');
            }
        }


        const callback = function(mutationsList, observer) {
            for (const mutation of mutationsList) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    
                    const isVisible = targetNode.classList.contains(visibleClass);
                    
                    if (isVisible) {
                        console.log(`%cCart Drawer Opened: Class "${visibleClass}" detected!`, 'color: #5ED26F; font-weight: bold;');

                        // Small delay to let OCU render items
                        setTimeout(enhanceCartLineItemsWithObserver, 50); // 👈 Use the new wrapper

                        // 🔁 NEW: watch for items being added/changed while cart is open
                        if (!itemsObserverAttached) {
                            
                            // 3. Initialize the observer here to call the wrapper function
                            itemsObserver = new MutationObserver(enhanceCartLineItemsWithObserver);

                            itemsObserver.observe(targetNode, {
                                childList: true,
                                subtree: true
                            });

                            itemsObserverAttached = true;
                            console.log('[Stage 2] Items observer attached.');
                        }
                         
                    } else {
                        console.log(`Cart Drawer Closed: Class "${visibleClass}" removed.`);
                        // Optional: disconnect the itemsObserver when the cart closes 
                        if (itemsObserverAttached && itemsObserver) {
                            itemsObserver.disconnect();
                            itemsObserverAttached = false;
                            console.log('[Stage 2] Items observer disconnected on cart close.');
                        }
                    }
                }
            }
        };

        const classObserver = new MutationObserver(callback);
        classObserver.observe(targetNode, config);
    }
    
    // --- Stage 1: wait for .ocu-cart-drawer to appear in DOM ---
    function waitForElementToAppear() {
        console.log(`[Stage 1] Searching for element: ${targetSelector} in the DOM...`);

        let targetNode = document.querySelector(targetSelector);
        if (targetNode) {
            observeCartClass(targetNode);
            return;
        }

        const parentNode = document.body;
        const parentConfig = { 
            childList: true, 
            subtree: true
        };

        const parentCallback = function(mutationsList, observer) {
            for (const mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach(node => {
                        if (node.nodeType === 1 && (node.matches(targetSelector) || node.querySelector(targetSelector))) {
                            
                            targetNode = node.matches(targetSelector) ? node : node.querySelector(targetSelector);
                            
                            observer.disconnect();
                            console.log(`[Stage 1] Element successfully located in the added DOM subtree. Disconnecting parent observer.`);
                            
                            observeCartClass(targetNode);
                        }
                    });
                }
            }
        };

        const parentObserver = new MutationObserver(parentCallback);
        parentObserver.observe(parentNode, parentConfig);
    }

    waitForElementToAppear();
});


function filterShopifyEvent(event, domElement, callback) {
    let executeCallback = false;
    if (event.type.includes('shopify:section')) {
        if (domElement.hasAttribute('data-section-id') && domElement.getAttribute('data-section-id') === event.detail.sectionId) executeCallback = true
    } else if (event.type.includes('shopify:block') && event.target === domElement) { 
        executeCallback = true 
    }
    if (executeCallback) callback(event)
}

// is in viewport
function inViewport(elem, callback, options = {}) {
    return new IntersectionObserver(entries => {
        entries.forEach(entry => callback(entry))
    }, options).observe(document.querySelector(elem));
}

/* How to inViewport
document.addEventListener("DOMContentLoaded", () => {
    inViewport('[data-inviewport]', element => {
        if (!element.isIntersecting) { document.querySelector('#add2cart-cta').classList.add('active') } 
        else { document.querySelector('#add2cart-cta').classList.remove('active') }
    });
});
*/

// Toggle Body Class
let toggleBodyClass = function(arg) { 
    document.body.classList.toggle(arg);
}
// Get Element Height
function getElementHeight(targetElement,appendTo,cssVar) {
    let element = document.querySelector(targetElement);

    if (element) {
        let elementHeight = element.offsetHeight;
        document.querySelector(appendTo).style.setProperty(cssVar, `${elementHeight}px`);
    }
}

// first we get the viewport height and we multiple it by 1% to get a value for a vh unit
const getSetVh = () => { const roundedVh = Math.round(window.innerHeight * 0.01); document.body.style.setProperty('--vh', `${roundedVh}px`) };
window.addEventListener('resize', getSetVh);

// Browser check
function getNavigator() {
    const isiOS = navigator.userAgent.match(/(iPhone|iPad|iPod)/) && navigator.userAgent.match(/AppleWebKit/) && !navigator.userAgent.match(/CriOS/);
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0 || navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime) || navigator.userAgent.indexOf('Chrome') != -1;
    const isFirefox = typeof InstallTrigger !== 'undefined' || navigator.userAgent.indexOf('Firefox') != -1;
    const isEdge = !!window.StyleMedia || navigator.userAgent.indexOf('Edge') != -1

    if (isiOS) document.documentElement.classList.add('ios');
    if (isSafari) document.documentElement.classList.add('safari');
    if (isChrome) document.documentElement.classList.add('chrome');
    if (isFirefox) document.documentElement.classList.add('firefox');
    if (isEdge) document.documentElement.classList.add('edge');
}

// Toggle
    let toggleClass = function(qSelectors, bodyClass) {   
        document.querySelectorAll(qSelectors).forEach(e => e.addEventListener('click', () => toggleBodyClass(bodyClass)))
    }
// Menu
    let toggleMenu = function() { 
        toggleClass('.fire-menu, .shrink-menu', 'open-menu')
    }


    function initializeDetailsControls() {
        // Handle dropdown menu
        const detailsElementsLv1 = document.querySelectorAll('details.lv1');
        const detailsElementsClosex = [...document.querySelectorAll('details.closex')];
    
        function closeOtherDetails(element) {
            const detailsOpened = document.querySelectorAll('details[open].lv1');
            for (const item of detailsOpened) {
                if (element !== item) {
                    item.removeAttribute('open');
                }
            }
        }

        function closeAllDetailsExcept(target) {
            detailsElementsClosex.forEach(f => !f.contains(target) ? f.removeAttribute('open') : '');
            a11yDetails();
        }
    
        function closeAllDetails() {
            detailsElementsClosex.forEach(f => f.removeAttribute('open'));
            a11yDetails();
        }
    
        // Dropdown menu
        detailsElementsLv1.forEach(item => {
            item.addEventListener('click', function() {
                closeOtherDetails(this);
            });
        });
    
        // Close details when clicked outside
        document.addEventListener('click', function(e) {
            if (!detailsElementsClosex.some(f => f.contains(e.target))) {
                closeAllDetails();
            } else {
                closeAllDetailsExcept(e.target);
            }
        });
    
        // Close details with esc key
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' || e.keyCode === 27) {
                closeAllDetails();
            }
        });
    
        // Initial accessibility settings
        a11yDetails();
    }

    function a11yDetails() {
        document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
            summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));
            
            if(summary.nextElementSibling.getAttribute('id')) {
                summary.setAttribute('aria-controls', summary.nextElementSibling.id);
            }
            
            summary.addEventListener('click', (event) => {
                event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
            });
        });
    }
    

// update button price on variant change 
function updatePrice(obj,idd) {
    var uid = obj.options[obj.selectedIndex].getAttribute('data-price');
    var pb = document.querySelector('.uprice'+idd);
    pb.innerHTML = uid;
}

function selectOptions(obj,idd) { updatePrice(obj,idd) }

// Debug
if (window.location.href.indexOf("debug") > -1) {
    var OpenThinking = OpenThinking || {}; OpenThinking.theme = { "name":"Bullet", "version":`${window.BOOMR.themeVersion}` };
    console.log(`${OpenThinking.theme.name} v${OpenThinking.theme.version}`);
}

// Bullet marquee
if (!customElements.get('bullet-marquee')) customElements.define('bullet-marquee', class bulletMarquee extends HTMLElement {
    constructor() { super(); if (window.ResizeObserver) new ResizeObserver(this.duration.bind(this)).observe(this); }

    duration(entries) {
        const scrollingSpeed = parseInt(this.getAttribute('bullet-speed') || 5);
        const contentWidth = entries[0].contentRect.width;
      
        // Calculate the slowFactor based on content width
        let slowFactor = contentWidth <= 375 ? 1 : contentWidth >= 1280 ? 3 : 1 + (contentWidth - 375) / (1280 - 375);

        // Calculate the scrolling speed with the adjusted slowFactor
        const scrollingDuration = (scrollingSpeed * slowFactor * entries[0].target.querySelector('span').clientWidth / contentWidth).toFixed(3);

        this.style.setProperty('--bullet-speed', `${scrollingDuration}s`);
    }
});

/*** init app */
function app() {
    getSetVh(); // get Viewport Height
    getNavigator(); // get the browser + OS
    toggleMenu(); // toggle Menu
    initializeDetailsControls(); // call details 
}

/*** on DOM ready **/
document.addEventListener("DOMContentLoaded", () => { app() })

document.addEventListener("DOMContentLoaded", function() {
  // Function to get all query parameters with the same name (e.g., 'filter.p.tag')
  function getUrlParameters(name) {
      var params = new URLSearchParams(window.location.search);
      var values = params.getAll(name);
      return values; // Returns an array of all the values for the same query parameter
  }

  // Get all 'filter.p.tag' values
  var filterTags = getUrlParameters('filter.p.tag');
  

  // Update the div for 'filter.p.tag' values
  if (filterTags) {
      var filterTagDiv = document.getElementById('filterTagDiv');
      filterTags.forEach(function(tag) {
          var span = document.createElement('span');
          span.innerText = tag;
          filterTagDiv.appendChild(span);
          // Optional: Add space or separator between tags
          filterTagDiv.appendChild(document.createTextNode(' ')); 
      });
  }
});

//Amazon Verified badge
// Amazon Verified Badge for "Cloud Control Hair Oil"
function assignAmazonVerifiedCloudControl() {
    const reviews = document.querySelectorAll('[data-product-title="Hydrating Hair Oil"]');
    const selectedReviews = Array.from(reviews).sort(() => 0.5 - Math.random()).slice(0, 2);
    reviews.forEach(review => {
        const badge = review.querySelector('.jdgm-rev__buyer-badge');
        if (badge) badge.classList.remove('amazon-verified');
    });
    selectedReviews.forEach(review => {
        const badge = review.querySelector('.jdgm-rev__buyer-badge');
        if (badge) badge.classList.add('amazon-verified');
    });
}

// Polling function for "Cloud Control Hair Oil"
function startPollingCloudControl(interval = 1000) {
    let lastReviewCount = 0;
    setInterval(() => {
        const reviews = document.querySelectorAll('[data-product-title="Hydrating Hair Oil"]');
        if (reviews.length !== lastReviewCount) {
            lastReviewCount = reviews.length;
            assignAmazonVerifiedCloudControl();
        }
    }, interval);
}

// Amazon Verified Badge for "Hydrating Pomade"
function assignAmazonVerifiedHydratingPomade() {
    const reviews = document.querySelectorAll('[data-product-title="Hydrating Pomade"]');
    const selectedReviews = Array.from(reviews).sort(() => 0.5 - Math.random()).slice(0, 2);
    reviews.forEach(review => {
        const badge = review.querySelector('.jdgm-rev__buyer-badge');
        if (badge) badge.classList.remove('amazon-verified');
    });
    selectedReviews.forEach(review => {
        const badge = review.querySelector('.jdgm-rev__buyer-badge');
        if (badge) badge.classList.add('amazon-verified');
    });
}

// Polling function for "Hydrating Pomade"
function startPollingHydratingPomade(interval = 1000) {
    let lastReviewCount = 0;
    setInterval(() => {
        const reviews = document.querySelectorAll('[data-product-title="Hydrating Pomade"]');
        if (reviews.length !== lastReviewCount) {
            lastReviewCount = reviews.length;
            assignAmazonVerifiedHydratingPomade();
        }
    }, interval);
}

// Amazon Verified Badge for "Matte Cream Clay"
function assignAmazonVerifiedMatteCreamClay() {
    const reviews = document.querySelectorAll('[data-product-title="Matte Cream Clay"]');
    const selectedReviews = Array.from(reviews).sort(() => 0.5 - Math.random()).slice(0, 2);
    reviews.forEach(review => {
        const badge = review.querySelector('.jdgm-rev__buyer-badge');
        if (badge) badge.classList.remove('amazon-verified');
    });
    selectedReviews.forEach(review => {
        const badge = review.querySelector('.jdgm-rev__buyer-badge');
        if (badge) badge.classList.add('amazon-verified');
    });
}

// Polling function for "Matte Cream Clay"
function startPollingMatteCreamClay(interval = 1000) {
    let lastReviewCount = 0;
    setInterval(() => {
        const reviews = document.querySelectorAll('[data-product-title="Matte Cream Clay"]');
        if (reviews.length !== lastReviewCount) {
            lastReviewCount = reviews.length;
            assignAmazonVerifiedMatteCreamClay();
        }
    }, interval);
}

// Amazon Verified Badge for "Heavy Hold Clay"
function assignAmazonVerifiedHeavyHoldClay() {
    const reviews = document.querySelectorAll('[data-product-title="Heavy Hold Clay"]');
    const selectedReviews = Array.from(reviews).sort(() => 0.5 - Math.random()).slice(0, 2);
    reviews.forEach(review => {
        const badge = review.querySelector('.jdgm-rev__buyer-badge');
        if (badge) badge.classList.remove('amazon-verified');
    });
    selectedReviews.forEach(review => {
        const badge = review.querySelector('.jdgm-rev__buyer-badge');
        if (badge) badge.classList.add('amazon-verified');
    });
}

// Polling function for "Heavy Hold Clay"
function startPollingHeavyHoldClay(interval = 1000) {
    let lastReviewCount = 0;
    setInterval(() => {
        const reviews = document.querySelectorAll('[data-product-title="Heavy Hold Clay"]');
        if (reviews.length !== lastReviewCount) {
            lastReviewCount = reviews.length;
            assignAmazonVerifiedHeavyHoldClay();
        }
    }, interval);
}

// Amazon Verified Badge for "Wax Fiber"
function assignAmazonVerifiedWaxFiber() {
    const reviews = document.querySelectorAll('[data-product-title="Wax Fiber"]');
    const selectedReviews = Array.from(reviews).sort(() => 0.5 - Math.random()).slice(0, 2);
    reviews.forEach(review => {
        const badge = review.querySelector('.jdgm-rev__buyer-badge');
        if (badge) badge.classList.remove('amazon-verified');
    });
    selectedReviews.forEach(review => {
        const badge = review.querySelector('.jdgm-rev__buyer-badge');
        if (badge) badge.classList.add('amazon-verified');
    });
}

// Polling function for "Wax Fiber"
function startPollingWaxFiber(interval = 1000) {
    let lastReviewCount = 0;
    setInterval(() => {
        const reviews = document.querySelectorAll('[data-product-title="Wax Fiber"]');
        if (reviews.length !== lastReviewCount) {
            lastReviewCount = reviews.length;
            assignAmazonVerifiedWaxFiber();
        }
    }, interval);
}

// Initialize for all products
document.addEventListener('DOMContentLoaded', () => {
    assignAmazonVerifiedCloudControl();
    startPollingCloudControl();

    assignAmazonVerifiedHydratingPomade();
    startPollingHydratingPomade();

    assignAmazonVerifiedMatteCreamClay();
    startPollingMatteCreamClay();

    assignAmazonVerifiedHeavyHoldClay();
    startPollingHeavyHoldClay();

    assignAmazonVerifiedWaxFiber();
    startPollingWaxFiber();
});

// Add CSS for the Amazon Verified badge
const style = document.createElement('style');
style.textContent = `.amazon-verified::before { content: "Amazon Verified" !important; }`;
document.head.appendChild(style);

// Create an observer to watch for changes in the DOM
const observer = new MutationObserver(function(mutationsList, observer) {
  // Select the first child .jdgm-subtab__name
  const nameElement2 = document.querySelector('.jdgm-subtab__name:first-child');
  if (nameElement2) {
    // Update the inner HTML to 'Reviews'
    nameElement2.innerHTML = 'Reviews';
  }

  // Select the second child .jdgm-subtab__name
  const nameElement = document.querySelector('.jdgm-subtab__name:nth-child(2)');
  if (nameElement) {
    // Update the inner HTML to 'Questions'
    nameElement.innerHTML = 'Questions';
  }

  // Disconnect the observer after the changes are made
  if (nameElement2 && nameElement) {
    observer.disconnect();
  }
});

// Configure the observer to watch for added nodes in the body
observer.observe(document.body, {
  childList: true,
  subtree: true
});


document.addEventListener('DOMContentLoaded', function () {
    // Select the first thumbnail button
    const firstThumbnailButton = document.querySelector('#shopify-section-template--16367940239426__main .thumbnail-slider__slide:first-child .thumbnail');

    // Add aria-current="true" to the first thumbnail button
    if (firstThumbnailButton) {
        firstThumbnailButton.setAttribute('aria-current', 'true');
    }
});

document.addEventListener("DOMContentLoaded", function () {
    // Select elements
    const mainSlider = document.querySelector("#shopify-section-template--16367940239426__main #Slider-Gallery-main");
    const slides = document.querySelectorAll("#shopify-section-template--16367940239426__main .slider__slide");
    const thumbnails = document.querySelectorAll("#shopify-section-template--16367940239426__main .thumbnail-slider__slide button");
    const totalSlides = slides.length;

    let currentIndex = 0;
    let isDragging = false;
    let startX;
    let scrollLeft;

    // Function to update active thumbnail based on main image scroll
    function updateActiveThumbnail(index) {
        if (index < 0) index = 0;
        if (index >= totalSlides) index = totalSlides - 1;

        // Remove active states
        thumbnails.forEach(thumb => thumb.removeAttribute("aria-current"));

        // Add active state to the correct thumbnail
        thumbnails[index].setAttribute("aria-current", "true");

        // Scroll active thumbnail into view
        thumbnails[index].scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });

        currentIndex = index;
    }

    // Detect swipe gesture on mobile
    let touchStartX = 0;
    let touchEndX = 0;
    let minSwipeDistance = 50;

    mainSlider.addEventListener("touchstart", (e) => {
        touchStartX = e.touches[0].clientX;
    });

    mainSlider.addEventListener("touchend", (e) => {
        touchEndX = e.changedTouches[0].clientX;
        let swipeDistance = touchStartX - touchEndX;

        if (swipeDistance > minSwipeDistance && currentIndex < totalSlides - 1) {
            updateActiveThumbnail(currentIndex + 1);
        } else if (swipeDistance < -minSwipeDistance && currentIndex > 0) {
            updateActiveThumbnail(currentIndex - 1);
        }
    });

    // Click event for thumbnails
    thumbnails.forEach((thumb, index) => {
        thumb.addEventListener("click", () => {
            updateActiveThumbnail(index);
        });
    });

    // **🔹 Dragging Functionality for Desktop**
    mainSlider.addEventListener("mousedown", (e) => {
        isDragging = true;
        startX = e.pageX - mainSlider.offsetLeft;
        scrollLeft = mainSlider.scrollLeft;
    });

    mainSlider.addEventListener("mouseup", () => {
        isDragging = false;
        snapToClosestSlide(); // 🔹 After dragging, sync thumbnail
    });

    mainSlider.addEventListener("mouseleave", () => {
        isDragging = false;
    });

    mainSlider.addEventListener("mousemove", (e) => {
        if (!isDragging) return;
        e.preventDefault();
        const x = e.pageX - mainSlider.offsetLeft;
        const walk = (x - startX) * 2; // Adjust speed
        mainSlider.scrollLeft = scrollLeft - walk;
    });

    // **🔹 Function to Snap to Closest Image**
    function snapToClosestSlide() {
        let closestIndex = Math.round(mainSlider.scrollLeft / slides[0].offsetWidth);
        updateActiveThumbnail(closestIndex);
    }

    // **🔹 Ensure thumbnails sync properly on desktop scroll**
    mainSlider.addEventListener("scroll", () => {
        if (!isDragging) {
            snapToClosestSlide();
        }
    });

    // Set first thumbnail as active
    updateActiveThumbnail(0);
});

document.addEventListener("DOMContentLoaded", function () {
    const slider = document.querySelector("#shopify-section-template--16367940239426__main #Slider-Gallery-main");

    let isDown = false;
    let startX;
    let scrollLeft;

    // Function to start dragging
    function startDrag(e) {
        isDown = true;
        slider.classList.add("active");
        startX = (e.pageX || e.touches[0].pageX) - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
    }

    // Function to stop dragging
    function endDrag() {
        isDown = false;
        slider.classList.remove("active");
        snapToClosestSlide(); // 🔹 Sync after drag
    }

    // Function to move slider
    function moveSlider(e) {
        if (!isDown) return;
        e.preventDefault();
        const x = (e.pageX || e.touches[0].pageX) - slider.offsetLeft;
        const walk = (x - startX) * 2; // Adjust speed
        slider.scrollLeft = scrollLeft - walk;
    }

    // Mouse Events (for desktop)
    slider.addEventListener("mousedown", startDrag);
    slider.addEventListener("mouseleave", endDrag);
    slider.addEventListener("mouseup", endDrag);
    slider.addEventListener("mousemove", moveSlider);

    // Touch Events (for mobile)
    slider.addEventListener("touchstart", startDrag);
    slider.addEventListener("touchend", endDrag);
    slider.addEventListener("touchmove", moveSlider);

    // **🔹 Function to Snap to Closest Image**
    function snapToClosestSlide() {
        let slides = document.querySelectorAll("#shopify-section-template--16367940239426__main .slider__slide");
        let closestIndex = Math.round(slider.scrollLeft / slides[0].offsetWidth);
        updateActiveThumbnail(closestIndex);
    }
});

// BM02 - V3 - Start
function initBM02V2Upsells() {
    // Only run when cart drawer is visible
    const checkCartVisibility = () => {
        const cartDrawer = document.querySelector('.ocu-cart-drawer');
        const isCartVisible = cartDrawer && cartDrawer.classList.contains('ocu-visible');
        
        if (isCartVisible) {
            const upsellSection = document.querySelector('.ocu-cart-upsell');
            if (upsellSection && !upsellSection.hasAttribute('data-bm02-initialized')) {
                // Add additional delay to ensure all content is loaded
                setTimeout(() => {
                    processBM02V2Upsells(upsellSection);
                }, 2500); // Wait 2.5 seconds after finding the section
            }
        }
    };

    // Check immediately in case cart is already open
    checkCartVisibility();

    // Listen for cart drawer visibility changes
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                // Check if the cart drawer visibility changed
                const cartDrawer = mutation.target;
                if (cartDrawer.classList.contains('ocu-cart-drawer')) {
                    const isCartVisible = cartDrawer.classList.contains('ocu-visible');
                    
                    if (isCartVisible) {
                        // Cart just became visible, wait a bit then check for upsells
                        setTimeout(() => {
                            checkCartVisibility();
                        }, 500);
                        
                        // Also force continuous styling update after a longer delay
                        setTimeout(() => {
                            const upsellSection = document.querySelector('.ocu-cart-upsell');
                            if (upsellSection) {
                                continuouslyUpdateUpsellStyling(upsellSection);
                                // Ensure drag and swipe functionality is working
                                addDragAndSwipeFunctionality(upsellSection);
                            }
                        }, 2000);
                    }
                }
            }
        });
    });

    // Enhanced observer for upsell content changes and cart updates
    const upsellObserver = new MutationObserver((mutations) => {
        let shouldReprocess = false;
        
        mutations.forEach((mutation) => {
            // Check for upsell content changes
            if (mutation.type === 'childList' && mutation.target.classList.contains('ocu-cart-upsell')) {
                shouldReprocess = true;
            }
            
            // Check for cart line item changes (items added/removed)
            if (mutation.type === 'childList' && mutation.target.classList.contains('ocu-cart-line-items')) {
                shouldReprocess = true;
            }
        });
        
        if (shouldReprocess) {
            // Reset the initialization flag and re-process
            const upsellSection = document.querySelector('.ocu-cart-upsell');
            if (upsellSection) {
                upsellSection.removeAttribute('data-bm02-initialized');
                // Wait a bit longer for the upsell section to fully re-render
                setTimeout(() => {
                    checkCartVisibility();
                }, 1500);
            }
        }
    });

    // Dedicated continuous observer for upsell styling
    const continuousUpsellObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            // Check for any changes in the upsell section
            if (mutation.type === 'childList' || mutation.type === 'attributes') {
                const upsellSection = document.querySelector('.ocu-cart-upsell');
                if (upsellSection && upsellSection.classList.contains('ocu-visible')) {
                    // Small delay to ensure DOM is stable
                    setTimeout(() => {
                        continuouslyUpdateUpsellStyling(upsellSection);
                        // Re-apply drag and swipe functionality after styling updates
                        addDragAndSwipeFunctionality(upsellSection);
                        

                    }, 300);
                }
            }
        });
    });

    // Start observing both upsell section and cart line items
    const existingUpsellSection = document.querySelector('.ocu-cart-upsell');
    const cartLineItems = document.querySelector('.ocu-cart-line-items');
    
    if (existingUpsellSection) {
        upsellObserver.observe(existingUpsellSection, {
            childList: true,
            subtree: true
        });
    }
    
    if (cartLineItems) {
        upsellObserver.observe(cartLineItems, {
            childList: true,
            subtree: true
        });
        

    }
    
    // Start observing the body for class changes on cart drawer
    observer.observe(document.body, {
        attributes: true,
        subtree: true,
        attributeFilter: ['class']
    });

    // Start the continuous upsell styling observer
    if (existingUpsellSection) {
        continuousUpsellObserver.observe(existingUpsellSection, {
            childList: true,
            subtree: true,
            attributes: true
        });
    }
    
    // Also watch for new upsell sections being created
    const bodyObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach((node) => {
                    if (node.classList && node.classList.contains('ocu-cart-upsell')) {
                        continuousUpsellObserver.observe(node, {
                            childList: true,
                            subtree: true,
                            attributes: true
                        });
                    }
                });
            }
        });
    });
    
    bodyObserver.observe(document.body, {
        childList: true,
        subtree: true
    });
    
    // Backup: Periodic check every 2 seconds when cart is visible
    setInterval(() => {
        const cartDrawer = document.querySelector('.ocu-cart-drawer');
        const isCartVisible = cartDrawer && cartDrawer.classList.contains('ocu-visible');
        
        if (isCartVisible) {
            const upsellSection = document.querySelector('.ocu-cart-upsell');
            if (upsellSection) {
                continuouslyUpdateUpsellStyling(upsellSection);
                // Also ensure drag and swipe functionality is working
                addDragAndSwipeFunctionality(upsellSection);
                

            }
        }
    }, 2000);
}

function processBM02V2Upsells(upsellSection) {
    // Wait for the actual product cards to load
    const waitForCards = setInterval(() => {
        const productCards = upsellSection.querySelectorAll('.ocu-product-card__container');
        
        if (productCards.length > 0) {
            clearInterval(waitForCards);
            
            // Mark as initialized to prevent duplicate processing
            upsellSection.setAttribute('data-bm02-initialized', 'true');
            
            // Process each card with proper sale detection
            processEachCard(productCards);
            
            // Add drag and swipe functionality for desktop
            addDragAndSwipeFunctionality(upsellSection);
        }
    }, 500); // Check every 500ms
    
                            // Stop checking after 10 seconds to prevent infinite loop
            setTimeout(() => {
                clearInterval(waitForCards);
            }, 10000);
}

function processEachCard(productCards) {
    productCards.forEach((card, index) => {
        // Remove any existing badges first
        removeExistingBadges(card);
        
        // Get product title to identify the specific product
        const productTitle = getProductTitle(card);
        
        // ALWAYS check current price structure - don't rely on stored data
        const originalPrice = card.querySelector('.ocu-price--was');
        const discountedPrice = card.querySelector('.ocu-price--now');
        
        if (originalPrice && discountedPrice) {
            // Calculate discount percentage
            const originalText = originalPrice.textContent;
            const discountedText = discountedPrice.textContent;
            const originalAmount = parseFloat(originalText.replace(/[^0-9.]/g, ''));
            const discountedAmount = parseFloat(discountedText.replace(/[^0-9.]/g, ''));
            const discountPercent = Math.round(((originalAmount - discountedAmount) / originalAmount) * 100);
            
            // Add "Save X%" badge
            addSaveBadge(card, discountPercent);
            
            // Apply discount styling
            applyDiscountStyling(card);
        } else {
            // Ensure no badge exists for non-discounted items
            removeExistingBadges(card);
        }
    });
}

function getProductTitle(card) {
    const titleElement = card.querySelector('.ocu-name p span');
    if (titleElement) {
        return titleElement.textContent.trim();
    }
    
    // Try alternative selector
    const titleElementAlt = card.querySelector('.ocu-name p p span');
    if (titleElementAlt) {
        return titleElementAlt.textContent.trim();
    }
    
    return 'Unknown Product';
}

function addDragAndSwipeFunctionality(upsellSection) {
    const cardsContainer = upsellSection.querySelector('.ocu-alignment__cards-container');
    if (!cardsContainer) return;
    
    // Check if drag functionality is already attached
    if (cardsContainer.hasAttribute('data-bm02-drag-enabled')) {
        return; // Already enabled
    }
    
    let isDragging = false;
    let startX = 0;
    let scrollLeft = 0;
    
    // Add CSS for better drag experience
    const dragStyles = `
        <style>
            .ocu-alignment__cards-container {
                cursor: grab !important;
                scroll-behavior: smooth !important;
            }
            
            .ocu-alignment__cards-container:active {
                cursor: grabbing !important;
            }
            
            /* Ensure all child elements inherit the grab cursor */
            .ocu-alignment__cards-container * {
                cursor: grab !important;
            }
            
            /* But keep pointer cursor for buttons */
            .ocu-alignment__cards-container button,
            .ocu-alignment__cards-container .ocu-product-add__button,
            .ocu-alignment__cards-container .ocu-add-to-card__container,
            .ocu-alignment__cards-container .ocu-ite-button--width,
            .ocu-alignment__cards-container .ocu-add-to-card__container p,
            .ocu-alignment__cards-container .ocu-ite-button--width p,
            .ocu-alignment__cards-container .ocu-add-to-card__container span,
            .ocu-alignment__cards-container .ocu-ite-button--width span,
            .ocu-alignment__cards-container a {
                cursor: pointer !important;
            }
            
            .ocu-alignment__cards-container::-webkit-scrollbar {
                height: 6px;
            }
            
            .ocu-alignment__cards-container::-webkit-scrollbar-track {
                background: #f1f1f1;
                border-radius: 3px;
            }
            
            .ocu-alignment__cards-container::-webkit-scrollbar-thumb {
                background: #888;
                border-radius: 3px;
            }
            
            .ocu-alignment__cards-container::-webkit-scrollbar-thumb:hover {
                background: #555;
            }
        </style>
    `;
    
    // Inject the styles
    if (!document.getElementById('bm02-drag-styles')) {
        const styleElement = document.createElement('div');
        styleElement.id = 'bm02-drag-styles';
        styleElement.innerHTML = dragStyles;
        document.head.appendChild(styleElement);
    }
    
    // Mouse events for desktop
    cardsContainer.addEventListener('mousedown', (e) => {
        // Don't start dragging on buttons or links
        if (e.target.closest('button') || e.target.closest('a') || e.target.closest('.ocu-product-add__button')) {
            return;
        }
        
        isDragging = true;
        startX = e.pageX - cardsContainer.offsetLeft;
        scrollLeft = cardsContainer.scrollLeft;
        cardsContainer.style.cursor = 'grabbing';
        cardsContainer.style.userSelect = 'none';
        cardsContainer.style.scrollBehavior = 'auto'; // Disable smooth scroll during drag
        
        // Prevent any default behaviors that might interfere
        e.preventDefault();
        e.stopPropagation();
    });
    
    cardsContainer.addEventListener('mousemove', (e) => {
        if (!isDragging) return;
        
        // Prevent default to avoid any interference
        e.preventDefault();
        e.stopPropagation();
        
        const x = e.pageX - cardsContainer.offsetLeft;
        const walk = (x - startX) * 2; // Scroll speed multiplier
        cardsContainer.scrollLeft = scrollLeft - walk;
    });
    
    cardsContainer.addEventListener('mouseup', (e) => {
        if (isDragging) {
            isDragging = false;
            cardsContainer.style.cursor = 'grab';
            cardsContainer.style.userSelect = 'auto';
            cardsContainer.style.scrollBehavior = 'smooth'; // Re-enable smooth scroll
        }
    });
    
    cardsContainer.addEventListener('mouseleave', () => {
        if (isDragging) {
            isDragging = false;
            cardsContainer.style.cursor = 'grab';
            cardsContainer.style.userSelect = 'auto';
            cardsContainer.style.scrollBehavior = 'smooth';
        }
    });
    
    // Touch events for mobile
    cardsContainer.addEventListener('touchstart', (e) => {
        // Don't start dragging on buttons or links
        if (e.target.closest('button') || e.target.closest('a') || e.target.closest('.ocu-product-add__button')) {
            return;
        }
        
        startX = e.touches[0].pageX - cardsContainer.offsetLeft;
        scrollLeft = cardsContainer.scrollLeft;
    });
    
    cardsContainer.addEventListener('touchmove', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const x = e.touches[0].pageX - cardsContainer.offsetLeft;
        const walk = (x - startX) * 2;
        cardsContainer.scrollLeft = scrollLeft - walk;
    });
    
    // Mark as enabled to prevent duplicate event listeners
    cardsContainer.setAttribute('data-bm02-drag-enabled', 'true');
}

// Continuous function to update upsell styling
function continuouslyUpdateUpsellStyling(upsellSection) {
    const productCards = upsellSection.querySelectorAll('.ocu-product-card__container');
    
    if (productCards.length === 0) return;
    
    productCards.forEach((card, index) => {
        // Remove any existing badges first
        removeExistingBadges(card);
        
        // Check current price structure
        const originalPrice = card.querySelector('.ocu-price--was');
        const discountedPrice = card.querySelector('.ocu-price--now');
        
        if (originalPrice && discountedPrice) {
            // Calculate discount percentage
            const originalText = originalPrice.textContent;
            const discountedText = discountedPrice.textContent;
            const originalAmount = parseFloat(originalText.replace(/[^0-9.]/g, ''));
            const discountedAmount = parseFloat(discountedText.replace(/[^0-9.]/g, ''));
            const discountPercent = Math.round(((originalAmount - discountedAmount) / originalAmount) * 100);
            
            // Add "Save X%" badge
            addSaveBadge(card, discountPercent);
            
            // Apply discount styling
            applyDiscountStyling(card);
        } else {
            // Ensure no badge exists for non-discounted items
            removeExistingBadges(card);
        }
    });

}

// Function to manually re-run the script (for testing)
function reRunBM02V2() {
    const upsellSection = document.querySelector('.ocu-cart-upsell');
    if (upsellSection) {
        upsellSection.removeAttribute('data-bm02-initialized');
        processBM02V2Upsells(upsellSection);
    }
}

// Manual function to test continuous styling
function testContinuousStyling() {
    const upsellSection = document.querySelector('.ocu-cart-upsell');
    if (upsellSection) {
        continuouslyUpdateUpsellStyling(upsellSection);
    }
}

function removeExistingBadges(card) {
    const existingBadges = card.querySelectorAll('.bm02-save-badge');
    existingBadges.forEach(badge => {
        badge.remove();
    });
}

function addSaveBadge(card, discountPercent) {
    // Remove existing badge if any
    removeExistingBadges(card);
    
    // Create save badge
    const saveBadge = document.createElement('div');
    saveBadge.className = 'bm02-save-badge';
    saveBadge.textContent = `SAVE ${discountPercent}%`;
    
    // Style the badge
    saveBadge.style.cssText = `
        position: absolute;
        top: 10px;
        left: 10px;
        background: #000;
        color: #fff;
        padding: 4px 8px 2px;
        font-size: 12px;
        font-family: Avenir;
        z-index: 2;
        border-radius: 0;
    `;
    
    // Insert badge at the beginning of the card
    card.insertBefore(saveBadge, card.firstChild);
    
    // Ensure the card has relative positioning for absolute badge positioning
    card.style.position = 'relative';
}

function applyDiscountStyling(card) {
    // Style the original price (strikethrough) - handle nested p structure
    const originalPrice = card.querySelector('.ocu-price--was p span');
    if (originalPrice) {
        originalPrice.style.cssText = `
            color: #000000 !important;
            font-size: 12px !important;
            font-weight: 500 !important;
            text-decoration: line-through !important;
            font-family: Avenir !important;
        `;
    } else {
        // Try alternative selector for nested structure
        const originalPriceAlt = card.querySelector('.ocu-price--was p p span');
        if (originalPriceAlt) {
            originalPriceAlt.style.cssText = `
                color: #000000 !important;
                font-size: 12px !important;
                font-weight: 500 !important;
                text-decoration: line-through !important;
                font-family: Avenir !important;
            `;
        }
    }
    
    // Style the discounted price - handle nested p structure
    const discountedPrice = card.querySelector('.ocu-price--now p span');
    if (discountedPrice) {
        discountedPrice.style.cssText = `
            color: #FF2020 !important;
            font-weight: 500 !important;
            font-size: 12px !important;
            font-family: Avenir !important;
        `;
    } else {
        // Try alternative selector for nested structure
        const discountedPriceAlt = card.querySelector('.ocu-price--now p p span');
        if (discountedPriceAlt) {
            discountedPriceAlt.style.cssText = `
                color: #FF2020 !important;
                font-weight: 500 !important;
                font-size: 12px !important;
                font-family: Avenir !important;
            `;
        }
    }
}

// Initialize BM02 when DOM is ready
document.addEventListener('DOMContentLoaded', initBM02V2Upsells);

// Also initialize when the page loads (for cases where DOMContentLoaded already fired)
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBM02V2Upsells);
} else {
    initBM02V2Upsells();
}

function initBM02V3Reviews() {
    
    // Function to add reviews when cart footer is available
    const addReviewsIfNeeded = () => {
        const cartFooter = document.querySelector('.ocu-cart-footer');
        if (cartFooter && !document.getElementById('bm02-v3-reviews')) {
            addBM02V3Reviews(cartFooter);
        }
    };

    // Check if cart drawer is visible and add reviews
    const checkAndAddReviews = () => {
        const cartDrawer = document.querySelector('.ocu-cart-drawer');
        const isCartVisible = cartDrawer && cartDrawer.classList.contains('ocu-visible');
        
        if (isCartVisible) {
            // Cart is visible, try to add reviews
            addReviewsIfNeeded();
        }
    };

    // Check immediately in case cart is already open
    checkAndAddReviews();

    // Listen for cart drawer visibility changes
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                const cartDrawer = mutation.target;
                if (cartDrawer.classList.contains('ocu-cart-drawer')) {
                    const isCartVisible = cartDrawer.classList.contains('ocu-visible');
                    if (isCartVisible) {
                        // Cart just became visible, add reviews
                        setTimeout(addReviewsIfNeeded, 500);
                    }
                }
            }
        });
    });

    // Start observing the body for class changes on cart drawer
    observer.observe(document.body, {
        attributes: true,
        subtree: true,
        attributeFilter: ['class']
    });
}

function addBM02V3Reviews(cartFooter) {
    // Find the cart__ctas div to insert after
    const cartCtas = cartFooter.querySelector('.cart__ctas');
    if (!cartCtas) {
        return;
    }
    
    // Create the reviews section
    const reviewsSection = document.createElement('div');
    reviewsSection.id = 'bm02-v3-reviews';
    reviewsSection.className = 'bm02-v3-reviews';
    
    // Add CSS styles
    const styles = `
        <style>
            .bm02-v3-reviews {
                display: flex;
                align-items: center;
                gap: 8px;
                margin: 15px 0 0;
                padding: 0 20px;
                justify-content: center;
            }
            
            .bm02-v3-reviews .stars-container {
                display: flex;
                align-items: center;
            }
            
            .bm02-v3-reviews .star {
                width: 16px;
                height: 16px;
                flex-shrink: 0;
            }
            
            .bm02-v3-reviews .reviews-text {
                font-family: Avenir;
                font-size: 14px;
                color: #000000;
                line-height: 1.2;
                font-weight: 450;
                margin-top: 3px;
            }
            
            .bm02-v3-reviews .rating {
                font-weight: 750;
                font-family: 'Avenir black';
            }
        </style>
    `;
    
    // Create the HTML structure
    reviewsSection.innerHTML = `
        ${styles}
        <div class="stars-container">
            <svg class="star" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <mask id="mask0_6234_912" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
                    <rect width="16" height="16" fill="#D9D9D9"/>
                </mask>
                <g mask="url(#mask0_6234_912)">
                    <path d="M7.99996 12.5285L4.29159 14.7666C4.15337 14.8474 4.01491 14.8813 3.87621 14.8684C3.73751 14.8556 3.612 14.8088 3.49968 14.7282C3.3872 14.6474 3.30037 14.5419 3.2392 14.4117C3.1782 14.2815 3.16843 14.1374 3.20989 13.9795L4.19436 9.7654L0.92043 6.9291C0.798096 6.82273 0.720168 6.6995 0.686646 6.55942C0.652965 6.41934 0.661782 6.28323 0.713099 6.1511C0.764415 6.01913 0.838371 5.91125 0.934967 5.82745C1.03156 5.74366 1.16359 5.68888 1.33104 5.66312L5.65163 5.28533L7.32911 1.30589C7.39012 1.15786 7.48266 1.04838 7.60674 0.977466C7.73083 0.90655 7.8619 0.871094 7.99996 0.871094C8.13802 0.871094 8.26909 0.90655 8.39317 0.977466C8.51725 1.04838 8.6098 1.15786 8.67081 1.30589L10.3483 5.28533L14.6689 5.66312C14.8363 5.68888 14.9684 5.74366 15.065 5.82745C15.1615 5.91125 15.2355 6.01913 15.2868 6.1511C15.3381 6.28323 15.347 6.41934 15.3133 6.55942C15.2797 6.6995 15.2018 6.82273 15.0795 6.9291L11.8056 9.7654L12.79 13.9795C12.8315 14.1374 12.8217 14.2815 12.7607 14.4117C12.6995 14.5419 12.6127 14.6474 12.5002 14.7282C12.3879 14.8088 12.2624 14.8556 12.1237 14.8684C11.985 14.8813 11.8465 14.8474 11.7083 14.7666L7.99996 12.5285Z" fill="#FFD200"/>
                </g>
            </svg>
            <svg class="star" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <mask id="mask0_6234_912" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
                    <rect width="16" height="16" fill="#D9D9D9"/>
                </mask>
                <g mask="url(#mask0_6234_912)">
                    <path d="M7.99996 12.5285L4.29159 14.7666C4.15337 14.8474 4.01491 14.8813 3.87621 14.8684C3.73751 14.8556 3.612 14.8088 3.49968 14.7282C3.3872 14.6474 3.30037 14.5419 3.2392 14.4117C3.1782 14.2815 3.16843 14.1374 3.20989 13.9795L4.19436 9.7654L0.92043 6.9291C0.798096 6.82273 0.720168 6.6995 0.686646 6.55942C0.652965 6.41934 0.661782 6.28323 0.713099 6.1511C0.764415 6.01913 0.838371 5.91125 0.934967 5.82745C1.03156 5.74366 1.16359 5.68888 1.33104 5.66312L5.65163 5.28533L7.32911 1.30589C7.39012 1.15786 7.48266 1.04838 7.60674 0.977466C7.73083 0.90655 7.8619 0.871094 7.99996 0.871094C8.13802 0.871094 8.26909 0.90655 8.39317 0.977466C8.51725 1.04838 8.6098 1.15786 8.67081 1.30589L10.3483 5.28533L14.6689 5.66312C14.8363 5.68888 14.9684 5.74366 15.065 5.82745C15.1615 5.91125 15.2355 6.01913 15.2868 6.1511C15.3381 6.28323 15.347 6.41934 15.3133 6.55942C15.2797 6.6995 15.2018 6.82273 15.0795 6.9291L11.8056 9.7654L12.79 13.9795C12.8315 14.1374 12.8217 14.2815 12.7607 14.4117C12.6995 14.5419 12.6127 14.6474 12.5002 14.7282C12.3879 14.8088 12.2624 14.8556 12.1237 14.8684C11.985 14.8813 11.8465 14.8474 11.7083 14.7666L7.99996 12.5285Z" fill="#FFD200"/>
                </g>
            </svg>
            <svg class="star" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <mask id="mask0_6234_912" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
                    <rect width="16" height="16" fill="#D9D9D9"/>
                </mask>
                <g mask="url(#mask0_6234_912)">
                    <path d="M7.99996 12.5285L4.29159 14.7666C4.15337 14.8474 4.01491 14.8813 3.87621 14.8684C3.73751 14.8556 3.612 14.8088 3.49968 14.7282C3.3872 14.6474 3.30037 14.5419 3.2392 14.4117C3.1782 14.2815 3.16843 14.1374 3.20989 13.9795L4.19436 9.7654L0.92043 6.9291C0.798096 6.82273 0.720168 6.6995 0.686646 6.55942C0.652965 6.41934 0.661782 6.28323 0.713099 6.1511C0.764415 6.01913 0.838371 5.91125 0.934967 5.82745C1.03156 5.74366 1.16359 5.68888 1.33104 5.66312L5.65163 5.28533L7.32911 1.30589C7.39012 1.15786 7.48266 1.04838 7.60674 0.977466C7.73083 0.90655 7.8619 0.871094 7.99996 0.871094C8.13802 0.871094 8.26909 0.90655 8.39317 0.977466C8.51725 1.04838 8.6098 1.15786 8.67081 1.30589L10.3483 5.28533L14.6689 5.66312C14.8363 5.68888 14.9684 5.74366 15.065 5.82745C15.1615 5.91125 15.2355 6.01913 15.2868 6.1511C15.3381 6.28323 15.347 6.41934 15.3133 6.55942C15.2797 6.6995 15.2018 6.82273 15.0795 6.9291L11.8056 9.7654L12.79 13.9795C12.8315 14.1374 12.8217 14.2815 12.7607 14.4117C12.6995 14.5419 12.6127 14.6474 12.5002 14.7282C12.3879 14.8088 12.2624 14.8556 12.1237 14.8684C11.985 14.8813 11.8465 14.8474 11.7083 14.7666L7.99996 12.5285Z" fill="#FFD200"/>
                </g>
            </svg>
            <svg class="star" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <mask id="mask0_6234_912" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
                    <rect width="16" height="16" fill="#D9D9D9"/>
                </mask>
                <g mask="url(#mask0_6234_912)">
                    <path d="M7.99996 12.5285L4.29159 14.7666C4.15337 14.8474 4.01491 14.8813 3.87621 14.8684C3.73751 14.8556 3.612 14.8088 3.49968 14.7282C3.3872 14.6474 3.30037 14.5419 3.2392 14.4117C3.1782 14.2815 3.16843 14.1374 3.20989 13.9795L4.19436 9.7654L0.92043 6.9291C0.798096 6.82273 0.720168 6.6995 0.686646 6.55942C0.652965 6.41934 0.661782 6.28323 0.713099 6.1511C0.764415 6.01913 0.838371 5.91125 0.934967 5.82745C1.03156 5.74366 1.16359 5.68888 1.33104 5.66312L5.65163 5.28533L7.32911 1.30589C7.39012 1.15786 7.48266 1.04838 7.60674 0.977466C7.73083 0.90655 7.8619 0.871094 7.99996 0.871094C8.13802 0.871094 8.26909 0.90655 8.39317 0.977466C8.51725 1.04838 8.6098 1.15786 8.67081 1.30589L10.3483 5.28533L14.6689 5.66312C14.8363 5.68888 14.9684 5.74366 15.065 5.82745C15.1615 5.91125 15.2355 6.01913 15.2868 6.1511C15.3381 6.28323 15.347 6.41934 15.3133 6.55942C15.2797 6.6995 15.2018 6.82273 15.0795 6.9291L11.8056 9.7654L12.79 13.9795C12.8315 14.1374 12.8217 14.2815 12.7607 14.4117C12.6995 14.5419 12.6127 14.6474 12.5002 14.7282C12.3879 14.8088 12.2624 14.8556 12.1237 14.8684C11.985 14.8813 11.8465 14.8474 11.7083 14.7666L7.99996 12.5285Z" fill="#FFD200"/>
                </g>
            </svg>
            <svg class="star" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <mask id="mask0_6234_916" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
                    <rect width="16" height="16" fill="#D9D9D9"/>
                </mask>
                <g mask="url(#mask0_6234_916)">
                    <path d="M7.99996 3.20029V10.6416L11.0027 12.4781L10.2163 9.04364L12.8615 6.754L9.38217 6.44395L7.99996 3.20029ZM7.99996 12.324L4.29159 14.5622C4.15337 14.6429 4.01491 14.6769 3.87621 14.664C3.73751 14.6511 3.612 14.6044 3.49968 14.5238C3.3872 14.443 3.30037 14.3375 3.2392 14.2073C3.1782 14.077 3.16843 13.933 3.20989 13.7751L4.19436 9.56096L0.92043 6.72467C0.798096 6.61829 0.720168 6.49507 0.686646 6.35499C0.652965 6.2149 0.661782 6.0788 0.713099 5.94667C0.764415 5.81469 0.838371 5.70681 0.934967 5.62302C1.03156 5.53922 1.16359 5.48444 1.33104 5.45869L5.65163 5.08089L7.32911 1.10145C7.39012 0.953418 7.48266 0.843944 7.60674 0.773029C7.73083 0.702113 7.8619 0.666656 7.99996 0.666656C8.13802 0.666656 8.26909 0.702113 8.39317 0.773029C8.51725 0.843944 8.6098 0.953418 8.67081 1.10145L10.3483 5.08089L14.6689 5.45869C14.8363 5.48444 14.9684 5.53922 15.065 5.62302C15.1615 5.70681 15.2355 5.81469 15.2868 5.94667C15.3381 6.0788 15.347 6.2149 15.3133 6.35499C15.2797 6.49507 15.2018 6.61829 15.0795 6.72467L11.8056 9.56096L12.79 13.7751C12.8315 13.933 12.8217 14.077 12.7607 14.2073C12.6995 14.3375 12.6127 14.443 12.5002 14.5238C12.3879 14.6044 12.2624 14.6511 12.1237 14.664C11.985 14.6769 11.8465 14.6429 11.7083 14.5622L7.99996 12.324Z" fill="#FFD200"/>
                </g>
            </svg>
        </div>
        <div class="reviews-text">
            <span class="rating">4.3</span> from 5000+ Reviews
        </div>
    `;
    
    // Insert the reviews section after the cart CTAs
    cartCtas.insertAdjacentElement('afterend', reviewsSection);
    
    // Start observing cart total changes for dynamic title updates
    observeCartTotalChanges();
}

// Function to change upsell title for V3
function changeUpsellTitle() {
    
    // Try multiple selectors to find the upsell title
    let upsellTitle = document.querySelector('.ocu-title p span') || 
                      document.querySelector('.ocu-title-embedded p span') ||
                      document.querySelector('[data-v-6ad7234b] .ocu-title p span');
    
    // If still not found, try to find by text content
    if (!upsellTitle) {
        const allSpans = document.querySelectorAll('span');
        for (const span of allSpans) {
            if (span.textContent.includes('You may also like') || 
                span.textContent.includes('Usually bought together') ||
                span.textContent.includes('Add these to get') ||
                span.textContent.includes('Congrats, you have')) {
                upsellTitle = span;
                break;
            }
        }
    }
    
    if (upsellTitle) {
        // Get cart total to determine which title to show
        const cartTotal = getCartTotal();
        
        // Always update the title based on current cart total
        let titleHTML;
        
        if (cartTotal >= 60) {
            // Cart total is $60 or more - show congratulations message
            titleHTML = `
                <span style="font-family: 'Avenir'!important;">Congrats, you have</span> 
                <span style="font-family: 'Avenir black'!important;">free shipping</span>
            `;
        } else {
            // Cart total is under $60 - show encouragement message
            titleHTML = `
                <span style="font-family: 'Avenir'!important;">Add these to get</span> 
                <span style="font-family: 'Avenir black'!important;">free shipping</span>
            `;
        }
        
        // Only update if the content is different
        const currentContent = upsellTitle.innerHTML.trim();
        const newContent = titleHTML.trim();
        
        if (currentContent !== newContent) {
            upsellTitle.innerHTML = titleHTML;
        }
        
        return true; // Success
    } else {
        return false; // Not found
    }
}

// Function to get cart total
function getCartTotal() {
    // Try to find cart total in various locations
    const cartTotalElement = document.querySelector('.ocu-cart-total') ||
                             document.querySelector('.cart__total-price') || 
                             document.querySelector('.cart-total') ||
                             document.querySelector('[data-cart-total]');
    
    if (cartTotalElement) {
        // Look for the money element specifically
        const moneyElement = cartTotalElement.querySelector('.money');
        
        if (moneyElement) {
            const totalText = moneyElement.textContent || moneyElement.innerText;
            // Extract number from text like "$88.20 USD" or "$88.20"
            const totalMatch = totalText.match(/[\d,]+\.?\d*/);
            if (totalMatch) {
                const total = parseFloat(totalMatch[0].replace(/,/g, ''));
                return total;
            }
        }
        
        // Fallback: search in the entire element text
        const totalText = cartTotalElement.textContent || cartTotalElement.innerText;
        const totalMatch = totalText.match(/[\d,]+\.?\d*/);
        if (totalMatch) {
            const total = parseFloat(totalMatch[0].replace(/,/g, ''));
            return total;
        }
    }
    
    // Fallback: return 0 if we can't find the total
    return 0;
}

// Function to observe cart total changes and update title accordingly
function observeCartTotalChanges() {
    
    // Start periodic updates as backup
    startPeriodicTitleUpdates();
    
    // Direct approach: Watch the cart total element for any changes
    const cartTotalElement = document.querySelector('.ocu-cart-total');
    if (cartTotalElement) {
        
        const cartTotalObserver = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'childList' || mutation.type === 'characterData') {
                    setTimeout(() => {
                        changeUpsellTitle();
                    }, 1000);
                }
            });
        });
        
        cartTotalObserver.observe(cartTotalElement, {
            childList: true,
            characterData: true,
            subtree: true
        });
        
    } else {
        setTimeout(() => observeCartTotalChanges(), 1000);
    }
}

// Function to periodically update the upsell title every 1.5 seconds
function startPeriodicTitleUpdates() {
    
    // Update title immediately
    changeUpsellTitle();
    
    // Then update every 0.5 seconds (very aggressive for V3)
    setInterval(() => {
        const cartDrawer = document.querySelector('.ocu-cart-drawer');
        const isCartVisible = cartDrawer && cartDrawer.classList.contains('ocu-visible');
        
        if (isCartVisible) {
            changeUpsellTitle();
        }
    }, 500);
}

// Function to manually re-run the script (for testing)
function reRunBM02V3() {
    const cartFooter = document.querySelector('.ocu-cart-footer');
    if (cartFooter) {
        const existingReviews = document.getElementById('bm02-v3-reviews');
        if (existingReviews) {
            existingReviews.remove();
        }
        addBM02V3Reviews(cartFooter);
    }
}

// Make it available globally for testing
window.reRunBM02V3 = reRunBM02V3;

// Initialize BM02 V3 when DOM is ready
document.addEventListener('DOMContentLoaded', initBM02V3Reviews);

// Also initialize when the page loads (for cases where DOMContentLoaded already fired)
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBM02V3Reviews);
} else {
    initBM02V3Reviews();
}

// BM02 - V3 - End


// Disable sold out button on the product pages

const button = document.querySelector('.BIS_trigger');
const ctaText = button.querySelector('.cta').textContent.trim();

if (ctaText.toUpperCase() === 'SOLD OUT') {
    button.disabled = true;       // Disable the button
}
